<ng-container *ngIf="readyIn">
    <button (click)="pay()" title="payer la commande" placement="bottom" class="btn btn-success">
        <ng-container *ngIf="loading">
            <i class='glyphicon glyphicon-refresh spinning'></i>
            &nbsp;&nbsp;
        </ng-container>
        Payer la commande
    </button>
  
    <span class="badge badge-exp badge-warning">
        Expire dans {{readyIn}} Min
    </span>
</ng-container>
<ng-container *ngIf="!readyIn">
    <span class="badge badge-exp badge-info">
        Expirée
    </span>
</ng-container>